import { RemoveRedEye, VisibilityOff } from "@mui/icons-material";
import { IconButton, Input } from "@mui/material";

interface Props {
  showPassword: boolean;
  onShowChange: () => void;
  onChange: (value: string) => void;
  value: string;
}

export default function PasswordInput({
  showPassword,
  onShowChange,
  onChange,
  value,
}: Props) {
  return (
    <Input
      autoComplete="password"
      type={showPassword ? "text" : "password"}
      placeholder="New Password"
      fullWidth
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      disableUnderline
      sx={{
        display: "flex !important",
      }}
      endAdornment={
        value ? (
          <IconButton
            size="small"
            onClick={onShowChange}
            title={showPassword ? "hide password" : "show password"}
          >
            {showPassword ? <VisibilityOff /> : <RemoveRedEye />}
          </IconButton>
        ) : undefined
      }
    />
  );
}
